import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './SelectFromLibraryTab.module.scss';
import FoldersListClipsModal from '../FoldersListClipsModal/FoldersListClipsModal';
import CardListClipsModal from '../CardListClipsModal/CardListClipsModal';
import Tabs from '../../features/Dashboard/components/Tabs/Tabs';
import { useTranslation } from 'react-i18next';
import useFetchListWithInfiniteScroll from '../../hooks/useFetchListWithInfiniteScroll';
import useFetchFoldersList from '../../hooks/useFetchFoldersList';
import VideoService from '../../service/VideoService';

const SelectFromLibraryTab = ({ searchInput, chosenFolder, handleFolderChoose, currentFolderName, updateFolderName }) => {
  const containerRef = useRef(null);
  const [tabsState, setTabsState] = useState({});
  const { t } = useTranslation();

  const [reset, setReset] = useState(false);

  const getVideosWithStats = useCallback(
    async query => {
      query.folder = chosenFolder;
      query.omitFiledStories = !query.searchTerm;
      query.include_empty = true;
      try {
        const response = await VideoService.getVideos(query);
        return new Promise(function(resolve) {
          return resolve(response);
        });
      } catch (err) {
        return new Promise(function(_, reject) {
          return reject(err);
        });
      }
    },
    [chosenFolder]
  );

  const {
    infiniteRef,
    list: videos,
    setList: setVideos,
    totalData,
    loadList: loadVideos,
    isEmptyList: isVideosEmpty,
    loading,
    searchInput: searchInputVideos,
    query,
  } = useFetchListWithInfiniteScroll({ service: getVideosWithStats, bottomMinOffset: -142, reset });

  const { loading: folderLoading, list: folders, query: folderQuery, searchInput: searchInputFolders } = useFetchFoldersList({});

  const handleTabClick = newState => {
    setTabsState(newState);
  };

  const onFolderChoose = useCallback(
    folderId => {
      setVideos([]);
      setReset(true);
      setTimeout(() => {
        handleFolderChoose(folderId);
        setReset(false);
      }, 10);
    },
    [handleFolderChoose]
  );

  useEffect(() => {
    if (chosenFolder) {
      const folder = folders.find(item => item.id === chosenFolder);
      if (folder) {
        updateFolderName(folder.name);
      }
    } else {
      updateFolderName('');
    }
  }, [chosenFolder]);

  useEffect(() => {
    searchInputVideos.onChange('searchTerm', searchInput.query);
    searchInputVideos.onChange('tags', searchInput?.tags?.map(tag => tag.id) ?? []);
    searchInputFolders.onChange(searchInput.query);
  }, [searchInput]);

  return (
    <div className={styles.wrapper} ref={containerRef}>
      {!(loading || folderLoading) && chosenFolder && (
        <div className={styles.headerContainer}>
          <h2 id="cardsHeaderID">{currentFolderName}</h2>
        </div>
      )}

      {!chosenFolder && <Tabs state={tabsState} onClick={handleTabClick} />}

      {!chosenFolder && (tabsState?.folders || tabsState?.team) && (
        <div>
          {loading || folderLoading ? (
            <h2>{t('general.loading')}</h2>
          ) : (
            folders?.filter(({ users }) => (tabsState?.team ? users?.length : !users?.length))?.length > 0 && (
              <h2>{tabsState?.team ? t('dashboard.team_folders.title') : t('dashboard.folders.title')} </h2>
            )
          )}
          {!(loading || folderLoading) ? (
            <FoldersListClipsModal
              isTeam={tabsState?.team}
              folders={folders}
              searchInput={searchInput.query}
              onClick={onFolderChoose}
              containerRef={containerRef}
            />
          ) : null}
        </div>
      )}

      {((!tabsState?.folders && !tabsState?.team && !chosenFolder) || chosenFolder) && (
        <>
          {loading || folderLoading ? (
            <h2>{t('general.loading')}</h2>
          ) : (
            !(query?.searchTerm && videos?.length === 0 && !isVideosEmpty) &&
            !chosenFolder && <h2 id="cardsHeaderID">{`${t('dashboard.all_videos')} (${videos && totalData})`}</h2>
          )}
          <CardListClipsModal
            infiniteRef={infiniteRef}
            loading={loading || folderLoading}
            videos={videos}
            searchInput={searchInput.query}
            tags={searchInput.tags}
            isVideosEmpty={isVideosEmpty}
          />
        </>
      )}
    </div>
  );
};

export default SelectFromLibraryTab;
